import { render } from "./DS100Input.vue?vue&type=template&id=5087afea"
import script from "./DS100Input.vue?vue&type=script&lang=js"
export * from "./DS100Input.vue?vue&type=script&lang=js"

import "./DS100Input.vue?vue&type=style&index=0&id=5087afea&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__